var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view engagement-management"},[_vm._m(0),_c('div',{staticClass:"content"},[_c('react-engagements-table')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Engagements overview")])])
}]

export { render, staticRenderFns }